import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { IconComponent } from '@atoms/icon/icon.component';
import { ParagraphComponent } from '@atoms/paragraph/paragraph.component';
import { TitleComponent } from '@atoms/title/title.component';

@Component({
  selector: 'app-form-thanks-message',
  imports: [NgClass, TranslateModule, IconComponent, ParagraphComponent, TitleComponent],
  templateUrl: './form-thanks-message.component.html',
  styleUrl: './form-thanks-message.component.scss',
})
export class FormThanksMessageComponent {
  @Input() type: 'default' | 'modal' = 'default';
  @Input() title?: string;
  @Input() description?: string;
}
